<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <order-state-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import OrderStateShowData from "./OrderStateShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "OrderStateShow",
        components: {CrudShow, OrderStateShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'delivery.orderState.showing',
            }
        },
    }
</script>

